/*
 * The end-of-timer sounds. One choice is used for every timer (focus, short, long, roulette), on the web
 * and in the phone app. The files are generated by scripts/make-alarms.js into public/sounds (web) and
 * android/.../res/raw (phone); 'system' is the phone's own alarm ringtone and exists only there.
 */
export const ALARM_SOUNDS = [
    'classic',
    'chime',
    'bell',
    'gentle',
    'siren',
] as const;
export type BundledAlarmSound = (typeof ALARM_SOUNDS)[number];
export type AlarmSoundId = BundledAlarmSound | 'system';

export const DEFAULT_ALARM_SOUND: AlarmSoundId = 'classic';

export const isAlarmSound = (id: unknown): id is AlarmSoundId =>
    id === 'system' || (ALARM_SOUNDS as readonly unknown[]).includes(id);

/** What the browser can play: 'system' falls back to the default. */
export const webSound = (id: AlarmSoundId): BundledAlarmSound =>
    id === 'system' ? 'classic' : id;

/** Plays the chosen sound once. Returns a function that stops it early. */
export const playAlarmSound = (id: AlarmSoundId): (() => void) => {
    try {
        const audio = new Audio(`/sounds/alarm-${webSound(id)}.wav`);
        audio.volume = 1;
        void audio.play().catch(() => undefined); // Blocked before any tap; harmless.
        return () => audio.pause();
    } catch {
        return () => undefined;
    }
};
